import { FileType } from './FileType';
export var BillStatus;
(function (BillStatus) {
    BillStatus["PENDING"] = "PENDING";
    BillStatus["INVALID"] = "INVALID";
    BillStatus["VALID"] = "VALID";
    BillStatus["PARSED"] = "PARSED";
})(BillStatus || (BillStatus = {}));
export const supportedBillFiletypeArray = [
    FileType.JPEG,
    FileType.PNG,
    FileType.TIFF,
    FileType.PDF,
];
